export default "__VITE_ASSET__B7U4vees__"